class SimilarCompany extends Company {
    constructor(companyData, parent) {
        super(companyData, parent);
        this.similarity = companyData.Similarity;
    }

    createCompanyDetailsCompactView() {
        const compactView = super.createCompanyDetailsCompactView();
        const content = document.createElement("div");
        content.classList.add("similarity-score-wrapper");
        content.appendChild(this.createSimilarityScoreHolder());
        compactView.prepend(content); // Add similarity score to start of view
        return compactView;
    }

    createSimilarityScoreHolder() {
        const percentFormat = new Intl.NumberFormat('en', { style: 'percent', maximumSignificantDigits: 2, minimumSignificantDigits: 2});
        const similarityScoreHolder = coreFunctions.createElementHelper("div", {class: "similarity-score-holder", "data-tooltip": "Similarity score", "data-tooltip_position": "bottom" });
        similarityScoreHolder.appendChild(this.createCircleScoreElement(this.similarity));
        similarityScoreHolder.appendChild(coreFunctions.createElementHelper("div", {innerHTML: percentFormat.format(this.similarity), class: "circle-score-text"})); // Score
        return similarityScoreHolder;
    }


}